/**
 * ProducerPopup Presentational Component
 * For more informations about this kind of component, read README
 *
 * References:
 *  - https://usehooks.com/useWindowSize/
 */

import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FiShare2 } from 'react-icons/fi';

import { Image, ShareButtons } from '../../../../components';
import TinyOfferCard from './TinyOfferCard';

import styles from './ProducerPopup.module.css';

/**
 * useProducersPopup UI logic hook.
 * Enable eventsHandlres to control UI behaviour and localStates to represent UI states.
 * @param {Commands} commands
 * @returns local states and events handles
 */
function useProducersPopup(commands) {
  const history = useHistory();

  const [showShareButtons, setShowShareButtons] = useState(false);

  const handleOpenProducerProfile = (nickname) => history.push(`/${nickname}`);
  const handleShareProducerClick = () => setShowShareButtons(!showShareButtons);

  return {
    localStates: {
      showShareButtons,
    },
    eventsHandlers: {
      handleOpenProducerProfile,
      handleShareProducerClick,
    },
  };
}

/**
 * ProducerPopup purely presentational component
 * Get user events and pass it to UI hook
 * @returns JSX presentational component
 */
export default function ProducerPopup(props) {
  const {
    commands,
    offers,
    producer,
    address,
  } = props;

  const { localStates, eventsHandlers } = useProducersPopup(commands);

  return producer ? (
    <div className={styles['popup-container']}>
      <div className={styles['popup-content']}>
        <section className={styles['popup-header']}>
          <div className={styles['producer-image']}>
            <Image src={producer.imagesPaths[producer.imagesPaths?.length - 1]} rounded />
          </div>

          <div className={styles['producer-info']}>
            <h1>{`@${producer.nickname}`}</h1>
            <h2>{producer.name}</h2>
            <p>
              {`${address.street}, ${address.number}. ${address.neighborhood}. ${address.city} - ${address.uf}`}
            </p>
          </div>
        </section>

        {
          offers?.length
            ? (
              <section className={styles['producer-offers']}>
                <div className={styles['offers-container']}>
                  {offers
                    .filter((offer) => offer.availableStock || offer.type === 'scheduled_delivery')
                    .slice(0, 2)
                    .map((offer) => (
                      <TinyOfferCard
                        key={offer.id}
                        offer={offer}
                        nickname={producer.nickname}
                      />
                    ))}

                  <button
                    type="button"
                    className={styles['offers-profile-button']}
                    onClick={() => eventsHandlers.handleOpenProducerProfile(producer.nickname)}
                  >
                    Ver mais...
                  </button>
                </div>
              </section>
            ) : <></>
        }

        <section className={styles['popup-options']}>
          <div className={styles['buttons-right']}>
            <button
              type="button"
              onClick={() => eventsHandlers.handleOpenProducerProfile(producer.nickname)}
            >
              <p>Ver perfil</p>
            </button>
          </div>

          <div className={styles['buttons-left']}>
            <button type="button">
              <ShareButtons
                display={localStates.showShareButtons}
                url={String(window.location)}
                title={`Venha conhecer as ofertas da(o) ${producer.name} no aplicativo Locall`}
                size="32px"
              />
              <FiShare2
                size={26}
                strokeWidth="2"
                color="#a53c34"
                onClick={eventsHandlers.handleShareProducerClick}
              />
            </button>
          </div>

        </section>
      </div>
    </div>
  ) : <></>;
}
